import { useSyncExternalStore } from "react";

/** Single bottom-of-screen toast, e.g. "Completed 'Buy milk' · Undo". */
export interface Toast {
  id: number;
  message: string;
  action?: { label: string; run: () => unknown };
}

let current: Toast | null = null;
let timer: ReturnType<typeof setTimeout> | undefined;
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());

export function showToast(message: string, action?: Toast["action"]): void {
  current = { id: Date.now(), message, action };
  clearTimeout(timer);
  timer = setTimeout(dismissToast, 6000);
  emit();
}

export function dismissToast(): void {
  current = null;
  emit();
}

export function useToast(): Toast | null {
  return useSyncExternalStore(
    (cb) => { listeners.add(cb); return () => { listeners.delete(cb); }; },
    () => current,
  );
}
